module.exports = __webpack_public_path__ + "img/BOxCart64_ua.4581ffe8.webp";